import { type BoxProps, Flex, Skeleton } from '@mantine/core'
import { ErrorBoundary } from '@suspensive/react'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import Sparkline from '@/components/chart/Sparkline'
import { NOT_APPLICABLE } from '@/configs'
import { coinPricesByIdQueryOptions } from '@/services/coin/prices'
import type { CoinId } from '@/types/coin'

const chartStyles: Omit<BoxProps, 'c'> = {
  w: '66px',
  h: '24px',
}

const skeleton = <Skeleton {...chartStyles} bdrs="40px" />

interface Props {
  coinId: CoinId
}

function PriceSparkline({ coinId }: Props) {
  const [inViewport, setInViewport] = useState(false)

  const { data, isLoading } = useQuery({
    enabled: inViewport,
    ...coinPricesByIdQueryOptions({
      coinId,
      interval: 'd',
    }),
  })
  const priceSamples = data?.prices?.map(([, price]) => price) ?? []

  return (
    <Sparkline
      data={priceSamples}
      isLoading={isLoading}
      {...chartStyles}
      fallback={skeleton}
      inViewOptions={{ onInView: () => !inViewport && setInViewport(true) }}
      style={{
        pointerEvents: 'none',
      }}
    />
  )
}

export default function PriceSparklineWrapper(props: Props) {
  return (
    <ErrorBoundary fallback={<>{NOT_APPLICABLE}</>}>
      <Flex w="100%" justify="flex-end">
        <PriceSparkline {...props} />
      </Flex>
    </ErrorBoundary>
  )
}
